export default {
  root: {
    minHeight: '48px !important',
  },
}
